import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { Tag } from "primereact/tag";

// Tabla de ítems de una categoría de documento de venta (presentacional).
// Incluye ítems nuevos de la cotización y existentes de asignaciones
// vigentes/futuras (marcados con Tag). Cada ítem se asigna obligatoriamente
// a uno de los documentos definidos para su tipo (opciones del dropdown con
// la etiqueta `${tipo} N`); el título usa la descripción exacta del catálogo
// (tipo_documento): una categoría nueva dada de alta en BD genera su tabla
// sin cambios de código.
const TablaCobroCategoria = ({
  categoria,
  visible,
  items,
  loadingAsig,
  options,
  onAsignarDocumento,
}) => (
  <div
    className="p-field"
    style={{
      marginTop: "10px",
      display: visible ? "flex" : "none",
      alignItems: "center",
    }}
  >
    <DataTable
      header={
        <span>
          <i
            className="pi pi-file"
            style={{ marginRight: "10px", color: "#42A5F5" }}
          ></i>
          {categoria}
        </span>
      }
      dataKey="id"
      style={{ width: "100%" }}
      showGridlines
      stripedRows="true"
      value={items}
      loading={loadingAsig}
      sortField="descripcion"
      sortOrder={1}
      className="p-datatable-gridlines"
    >
      <Column
        field="descripcion"
        header="Item"
        style={{ width: "40%" }}
        body={(rowData) => {
          const tramo =
            rowData.tramo && rowData.tramo !== "null"
              ? ` (${rowData.tramo})`
              : "";
          return (
            <div className="flex flex-column gap-1">
              <span>{`${rowData.descripcion}${tramo}`}</span>
              {rowData.existente && (
                <span className="flex align-items-center gap-1">
                  <Tag
                    value={rowData.vigencia === "futura" ? "Futura" : "Vigente"}
                    severity={rowData.vigencia === "futura" ? "info" : "success"}
                    className="p-tag-sm"
                  />
                  <span style={{ fontSize: "11px", color: "#64748b" }}>
                    Asignación #{rowData.asignacionId}
                  </span>
                </span>
              )}
            </div>
          );
        }}
      />

      <Column
        field="relacion"
        header="Relación"
        style={{ width: "20%" }}
        body={(rowData) => {
          if (rowData.relacion === "producto" || rowData.relacion === "subproducto") {
            return "Arriendo";
          } else if (
            rowData.descripcion?.toLowerCase().includes("habilitacion") ||
            rowData.descripcion?.toLowerCase().includes("obra civil")
          ) {
            return "Servicio único";
          } else {
            return "Servicio";
          }
        }}
      />

      <Column
        field="agrupamiento"
        header="Documento"
        style={{ width: "40%" }}
        body={(rowData) => (
          <div className="flex align-items-center justify-content-center gap-2">
            <Dropdown
              value={Number(rowData.agrupamiento) > 0 ? Number(rowData.agrupamiento) : null}
              options={options}
              onChange={(e) => onAsignarDocumento(rowData, e)}
              placeholder="Seleccionar"
            />
            {!(Number(rowData.agrupamiento) > 0) && (
              <Tag
                value="Sin asignar"
                severity="warning"
                className="p-tag-sm"
              />
            )}
          </div>
        )}
      />
    </DataTable>
  </div>
);

export default TablaCobroCategoria;